import classnames from "classnames";
import { PropsWithChildren } from "react";
import { ButtonKind, FauxButton } from "../../../../../core/ui";
import "./UsersButton.style.scss";

interface UsersFauxButtonProps {
  className?: string;
  target?: string;
  to: string;
}

export function UsersFauxButton({ className, to, children, target }: PropsWithChildren<UsersFauxButtonProps>) {
  return (
    <FauxButton
      className={classnames("component-users-button", { [`${className}`]: !!className })}
      kind={ButtonKind.CUSTOMIZED}
      target={target}
      to={to}
    >
      {children}
    </FauxButton>
  );
}
